import { Link } from 'react-router-dom';

import { IconHeart } from '../../common/icons';
import { meta } from '../../global/config/api';
import CHANGELOG from './changelog';

import './styles/footer.css';

const CURRENT_VERSION = CHANGELOG[0].version;
const CURRENT_YEAR = new Date().getFullYear();
const CONTACT_EMAIL = 'contacto@petroniotv.com';

export default function Footer() {
    return (
        <footer className="footer">
            <div className="footer__top">
                <div className="footer__brand">
                    <img className="footer__logo" src="/logo.svg" alt={meta.projectName} />
                    <p className="footer__tagline">
                        Panel de administración de PetronioTV.
                    </p>
                </div>

                {/* Sin sitio público todavía: aquí iban Explorar (inicio, canales,
                    catálogo) y los enlaces legales. Vuelven cuando exista. */}
                <nav className="footer__col" aria-label="Gestión">
                    <span className="footer__col-title">Gestión</span>
                    <Link to="/admin/channels" className="footer__link">Canales</Link>
                    <Link to="/admin/videos" className="footer__link">Videos</Link>
                    <Link to="/admin/news" className="footer__link">Noticias</Link>
                </nav>

                <nav className="footer__col" aria-label="Cuenta">
                    <span className="footer__col-title">Cuenta</span>
                    <Link to="/login" className="footer__link">Iniciar sesión</Link>
                    <Link to="/admin" className="footer__link">Panel de administración</Link>
                </nav>

                <nav className="footer__col" aria-label="Soporte">
                    <span className="footer__col-title">Soporte</span>
                    <a href={`mailto:${CONTACT_EMAIL}`} className="footer__link">Contacto</a>
                </nav>
            </div>

            <div className="footer__bottom">
                <span className="footer__copy">
                    © {CURRENT_YEAR} {meta.projectName}. Todos los derechos reservados.
                </span>
                <span className="footer__made">
                    Desarrollado con <IconHeart /> por Trianametria Software
                </span>
                <Link to="/admin/changelog" className="footer__version">{CURRENT_VERSION}</Link>
            </div>
        </footer>
    );
}
